import Box from "@cloudscape-design/components/box"
import BreadcrumbGroup from "@cloudscape-design/components/breadcrumb-group"
import { useNavigate } from "react-router-dom"

interface BreadcrumbItem {
  label: string
  path?: string | undefined
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const navigate = useNavigate()

  const cloudscapeItems = items.map((item) => ({
    text: item.label,
    href: item.path ?? "",
  }))

  return (
    <Box padding={{ vertical: "xs" }} margin={{ bottom: "xs" }}>
      <BreadcrumbGroup
        items={cloudscapeItems}
        ariaLabel="Breadcrumb"
        onFollow={(event) => {
          // Cloudscape links navigate via full page load by default; intercept and
          // use the router instead. Items without a path have href "" and are no-ops.
          event.preventDefault()
          if (event.detail.href) {
            navigate(event.detail.href)
          }
        }}
      />
    </Box>
  )
}

export default Breadcrumb
